/**
 * Deep link handler component for native Capacitor apps
 * Listens for app URL open events and routes within the SPA
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initializeDeepLinks, parseDeepLinkUrl } from '@/lib/deepLinks';

export function DeepLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleUrl = (url: string) => {
      const parsed = parseDeepLinkUrl(url);
      if (parsed) {
        // Navigate using React Router
        navigate(parsed.path, { replace: true });
      }
    };

    const cleanup = initializeDeepLinks(handleUrl);
    return cleanup;
  }, [navigate]);

  return null; // This component doesn't render anything
}
